<!-- 
  详情页 - 左侧基本信息
  props:
    id: Number 客户关联id
    moduleName: String 模块名
    showTitle: Boolean 是否显示标题
 -->

<template>
  <div class="sale-team">
    <h3 class="title" v-if="showTitle">{{title}}</h3>
    <div class="content">
      <dl>
        <dt>负责人</dt>
        <dd class="user-list" v-for="item in manager" :key="item.id">
          <span class="item avatar" :class="{'active': deleteManagerStatus}">
            <img width="32" height="32" :src="item.userAvatar" :alt="item.userName">
            <i class="delete el-icon-circle-close" @click="handleDel(item.id)"></i>
          </span>
          <span class="text">{{item.userName}}</span>

          <el-button size="small" class="hand-over" @click="handover(item.userId)" v-if="moduleName === 'customerApi' && isCustomerHandover">移交</el-button>
        </dd>
        <dd class="user-list flex" v-if="moduleName !== 'workOrder' && isSummit">
          <span class="item option" @click="add('manager')">
            <i class="el-icon-plus"></i>
          </span>
          <span class="item option" @click="deleteManagerStatus = !deleteManagerStatus">
            <i class="el-icon-minus"></i>
          </span>
        </dd>
      </dl>
      <dl>
        <dt>协同人</dt>
        <dd class="user-list flex">
          <el-tooltip v-for="(item, index) in cooperative" v-if="index < cooperCount" effect="dark" :content="item.userName" :key="item.id" placement="top">
            <span class="item avatar" :class="{'active': deleteStatus}">
              <img width="32" height="32" :src="item.userAvatar" :alt="item.userName">
              <i class="delete el-icon-circle-close" @click="del(item.id)"></i>
            </span>
          </el-tooltip>
          <span v-show="cooperative.length > 3" class="item option more" @click="toggleMore">
            <i class="el-icon-more"></i>
          </span>
          <span class="item option" @click="add('cooperative')">
            <i class="el-icon-plus"></i>
          </span>
          <span class="item option" @click="toggleStatus">
            <i class="el-icon-minus"></i>
          </span>
        </dd>
      </dl>
    </div>
    <team-person 
      v-if="teamPersonShow" 
      :transferId="transferId" 
      :selectIds="id" 
      :modal="false" 
      :detailModule="moduleName" 
      :module="operationType"
      :saleTeams="saleTeams"
      @refresh="refreshSaleTeam" 
      @closeDialog="closeDialog"
      >
    </team-person>
    <div class="v-modal" v-show="teamPersonShow"></div>
  </div>
</template>

<script>
  import * as api from 'src/api'
  import { MessageBox } from 'element-ui'
  import * as common from 'src/config/common-config'
  import TeamPerson from 'components/modal/customer/team-person'

  export default {
    created () {
      this.getSaleTeam()
    },
    props: {
      id: {
        type: Number
      },
      moduleName: {
        type: String
      },
      showTitle: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        // 负责人
        manager: [],
        // 协同人
        cooperative: [],
        // 协同人显示的数量
        cooperCount: 3,
        // 是否进入删除模式
        deleteStatus: false,
        deleteManagerStatus: false,
        teamPersonShow: false,
        moduleApi: common.moduleApi,
        // 是否具有删除负责人的权限
        isSummit: false,
        operationType: '', // 知道操作的是负责人还是协同人
        transferId: '', // 要移交人的id
        saleTeams: [] // 所有团队成员
      }
    },

    computed: {
      title () {
        if (this.moduleName === 'workOrder') {
          return '协同团队'
        } else if (this.moduleName === 'supplier' || this.moduleName === 'purchase') {
          return '采购团队'
        } else if (this.moduleName === 'bomBill' || this.moduleName === 'productionOrder') {
          return '生产团队'
        } else {
          return '销售团队'
        }
      }
    },
    methods: {
      refreshSaleTeam () {
        this.getSaleTeam()
        this.$emit('refresh')
      },
      // 获取销售团队
      getSaleTeam (id) {
        const url = `/staffApi/getMyTeam.html`
        const params = {
          refType: this.moduleApi[this.moduleName],
          refId: id || this.id,
          isSync: true // 强制按请求顺序返回数据
        }
        api.post(url, params, (data) => {
          // 清空默认值
          this.manager = []
          this.cooperative = []
          this.isSummit = data.isSummit
          this.saleTeams = data.result
          // 客户移交权限
          this.isCustomerHandover = data.isCustomerHandover

          data.result.forEach(item => {
            if (item.isMain) {
              this.manager.push(item)
            } else {
              this.cooperative.push(item)
            }
          })
        })
      },
      // 切换是否展示更多协同人
      toggleMore () {
        if (this.cooperCount === 3) {
          this.cooperCount = 100
        } else {
          this.cooperCount = 3
        }
      },
      // 移交
      handover (id) {
        MessageBox.confirm(`确认移交这位客户吗?`, '移交确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.transferId = id
          this.operationType = 'transfer'
          this.teamPersonShow = true
        }).catch(() => {})
      },
      // 删除负责人
      handleDel (id) {
        MessageBox.confirm(`确认删除该负责人吗?`, '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(id)
        }).catch(() => {})
      },
      // 新增协同人
      add (type) {
        this.operationType = type
        this.teamPersonShow = true
      },
      // 删除协同人 & 负责人
      del (id) {
        const url = '/staffApi/delFromTeam.html'
        const params = {
          refType: this.moduleApi[this.moduleName],
          refId: id
        }
        api.post(url, params, (data) => {
          this.refreshSaleTeam()
        })
      },
      // 切换协同人删除状态
      toggleStatus () {
        this.deleteStatus = !this.deleteStatus
      },
      // 监听弹窗关闭状态
      closeDialog () {
        this.teamPersonShow = false
      }
    },
    components: {
      TeamPerson
    }
  }
</script>

<style lang="less" scoped>
@import "../../assets/less/variable.less";
.sale-team {
  overflow: hidden;
  .title {
    background-color: @bg-lightblue;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
  }
  .content {
    clear: both;
    padding: 10px 20px 20px;
    dl {
      dt {
        font-size: 12px;
        color: @light-gray;
        margin: 10px 0 15px;
      }
      .user-list {
        position: relative;
        &.flex {
          display: flex;
          flex-wrap: wrap;
          width: 105%;
          .item {
            margin-right: 15px;
          }
        }
        .item {
          display: inline-block;
          vertical-align: top;
          height: 32px;
          width: 32px;
          margin-bottom: 10px;
        }
        .text {
          margin-left: 8px;
          vertical-align: top;
          line-height: 32px;
        }
        .hand-over {
          position: absolute;
          right: 0;
          top: 2px;
        }
        .red {
          position: absolute;
          right: 66px;
          top: 3px;
          color: red;
          display: none;
          &:hover {
            text-decoration: underline;
          }
        }
        .avatar {
          position: relative;
          img {
            border-radius: 50%;
            overflow: hidden;
          }
          .delete {
            position: absolute;
            right: -5px;
            top: -5px;
            color: @bg-red;
            cursor: pointer;
            transition: all 0.1s;
            display: none;
            &:hover {
              transform: scale(1.1);
            }
          }
          &.active {
            .delete {
              display: block;
            }
          }
        }
        .option {
          border-radius: 50%;
          background-color: #dce1e8;
          line-height: 32px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          &.more {
            background-color: #78e0cf;
          }
          &:hover {
            opacity: 0.8;
          }
        }
        &:hover {
          .red {
            display: inline-block;
          }
        }
      }
    }
  }
  .v-modal {
    position: fixed;
    z-index: 500;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #000;
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// sale-team.vue?9bf82dd4